import React, { useContext } from 'react'
import { RiskProductsContext } from '../context'
import { TabHeader } from '@components/TabHeader'

export const Header = () => {
  const { state } = useContext(RiskProductsContext)
  const { title, filter, screen } = state
  return (
    <TabHeader title={title}>
      <TabHeader.Filter filter={filter} view={screen} />
    </TabHeader>
  )
}
